(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["AG1-research"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-inres]').forEach(function(root){
    if (root.dataset.inited) return;
    root.dataset.inited = '1';
    var tabs = root.querySelectorAll('.inres__tab');
    var panels = root.querySelectorAll('.inres__panel');
    tabs.forEach(function(tab){
      tab.addEventListener('click', function(){
        var id = tab.getAttribute('data-tab');
        tabs.forEach(function(t){ t.classList.remove('is-active'); });
        panels.forEach(function(p){ p.classList.remove('is-active'); });
        tab.classList.add('is-active');
        var panel = root.querySelector('[data-panel="'+id+'"]');
        if (panel) panel.classList.add('is-active');
        tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buy-mini"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.inbs').forEach(function(root){
  var qty = root.querySelector('[data-qty]');
  root.querySelector('[data-qm]')?.addEventListener('click', function(){ qty.value = Math.max(1, parseInt(qty.value||1)-1); });
  root.querySelector('[data-qp]')?.addEventListener('click', function(){ qty.value = parseInt(qty.value||1)+1; });

  var addBtn = root.querySelector('[data-add]');
  if(!addBtn) return;
  addBtn.addEventListener('click', function(){
    var origLabel = addBtn.textContent;
    addBtn.disabled = true;
    var fd = new FormData();
    fd.append('id', addBtn.dataset.vid);
    fd.append('quantity', qty.value || 1);
    fd.append('sections', 'cart-icon-bubble,cart-drawer');
    fd.append('sections_url', window.location.pathname);
    fetch('/cart/add.js', {method:'POST', body: fd, headers:{'Accept':'application/javascript','X-Requested-With':'XMLHttpRequest'}})
      .then(function(r){ return r.json(); })
      .then(function(data){
        if(data.status){ throw data; }
        if(data.sections && data.sections['cart-icon-bubble']){
          var bubble = document.getElementById('cart-icon-bubble');
          if(bubble){
            var html = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
            var newInner = html.querySelector('#shopify-section-cart-icon-bubble');
            if(newInner) bubble.innerHTML = newInner.innerHTML;
          }
        }
        if(data.sections && data.sections['cart-drawer']){
          var drawer = document.querySelector('cart-drawer');
          if(drawer){
            var dHtml = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
            var dInner = dHtml.querySelector('cart-drawer');
            if(dInner) drawer.innerHTML = dInner.innerHTML;
            drawer.classList.remove('is-empty');
          }
        }
        addBtn.textContent = '✓ Hinzugefügt';
        setTimeout(function(){ addBtn.textContent = origLabel; addBtn.disabled = false; }, 1800);
      })
      .catch(function(err){
        console.error(err);
        addBtn.disabled = false;
        addBtn.textContent = origLabel;
        alert('Fehler beim Hinzufügen.');
      });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in-1vorteile-pro"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.invp').forEach(function(sec){
    var vp=sec.querySelector('.invp__viewport');
    var dotsBox=sec.querySelector('.invp__dots');
    var grid=sec.querySelector('.invp__grid');
    if(!vp||!grid||!dotsBox) return;
    var cards=grid.children;
    var pages=Math.ceil(cards.length/2/2);
    if(window.matchMedia('(min-width:900px)').matches){return;}
    dotsBox.innerHTML='';
    for(var i=0;i<pages;i++){
      var b=document.createElement('button');
      b.className='invp__dot'+(i===0?' is-active':'');
      b.setAttribute('aria-label','Slide '+(i+1));
      b.dataset.idx=i;
      dotsBox.appendChild(b);
    }
    var dots=dotsBox.querySelectorAll('.invp__dot');
    dots.forEach(function(d){
      d.addEventListener('click',function(){
        var i=parseInt(d.dataset.idx,10);
        vp.scrollTo({left:i*vp.clientWidth*0.92,behavior:'smooth'});
      });
    });
    vp.addEventListener('scroll',function(){
      var i=Math.round(vp.scrollLeft/(vp.clientWidth*0.92));
      dots.forEach(function(d,n){d.classList.toggle('is-active',n===i)});
    },{passive:true});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in-badges"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-inbg]').forEach(function(root){
    if (root.dataset.inited) return;
    root.dataset.inited = '1';
    var track = root.querySelector('[data-inbg-track]');
    var bar = root.querySelector('[data-inbg-bar]');
    if (!track || !bar) return;
    function update(){
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 0) { bar.style.transform = 'scaleX(1)'; return; }
      var ratio = track.scrollLeft / max;
      var barW = track.clientWidth / track.scrollWidth;
      bar.style.width = (barW * 100) + '%';
      bar.style.transform = 'translateX(' + (ratio * (100/barW - 100)) + '%)';
    }
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in-bundle"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-inbn]').forEach(function(root){
    if (root.dataset.inited) return;
    root.dataset.inited = '1';
    root.querySelectorAll('[data-inbn-group]').forEach(function(group){
      var chips = group.querySelectorAll('.inbn__chip');
      chips.forEach(function(chip){
        chip.addEventListener('click', function(){
          chips.forEach(function(c){ c.classList.remove('is-active'); });
          chip.classList.add('is-active');
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in-buy-card"] && !Shopify.designMode) return;
  try {
    
(function(){
  const root = document.currentScript ? document.currentScript.closest('.inbc') : document.querySelector('.inbc');
  if(!root) return;
  const idIn = root.querySelector('[data-id]');
  const priceEl = root.querySelector('[data-price]');
  const cur = root.querySelector('[data-cur]');
  root.querySelectorAll('[data-pills] input').forEach(r=>{
    r.addEventListener('change',()=>{
      root.querySelectorAll('.inbc__pill').forEach(p=>p.classList.remove('is-on'));
      r.closest('.inbc__pill').classList.add('is-on');
      if(idIn) idIn.value = r.dataset.vid;
      if(priceEl && r.dataset.price) priceEl.textContent = r.dataset.price;
      if(cur) cur.textContent = r.value;
    });
  });
  const qty = root.querySelector('[data-qty]');
  root.querySelector('[data-qm]')?.addEventListener('click',()=>{qty.value=Math.max(1,parseInt(qty.value)-1)});
  root.querySelector('[data-qp]')?.addEventListener('click',()=>{qty.value=parseInt(qty.value)+1});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in-now"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-invs]').forEach(function(root){
    if (root.dataset.inited) return;
    root.dataset.inited = '1';
    var track = root.querySelector('[data-invs-track]');
    var prev = root.querySelector('[data-invs-prev]');
    var next = root.querySelector('[data-invs-next]');
    if (!track) return;
    function step(){
      var card = track.querySelector('.invs__alt');
      if (!card) return 260;
      var styles = window.getComputedStyle(track);
      var gap = parseInt(styles.gap) || 10;
      return card.offsetWidth + gap;
    }
    function update(){
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 0;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function(){ track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function(){ track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in-shop-circles"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.inpc').forEach(function(sec){
    var circles=sec.querySelectorAll('.inpc__circle');
    var panels=sec.querySelectorAll('.inpc__panel');
    circles.forEach(function(b,i){
      b.addEventListener('click',function(){
        circles.forEach(function(x,n){x.classList.toggle('is-active',n===i)});
        panels.forEach(function(x,n){x.classList.toggle('is-active',n===i)});
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in-shop"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-inps]').forEach(function(root){
    if (root.dataset.inited) return;
    root.dataset.inited = '1';
    var filters = root.querySelectorAll('[data-inps-filter]');
    var cards = root.querySelectorAll('.inps__card');
    filters.forEach(function(btn){
      btn.addEventListener('click', function(){
        var val = btn.getAttribute('data-inps-filter');
        filters.forEach(function(b){ b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        cards.forEach(function(c){
          var cat = c.getAttribute('data-inps-cat');
          if (val === 'alle' || cat === val || !cat) { c.classList.remove('is-hidden'); }
          else { c.classList.add('is-hidden'); }
        });
        var track = root.querySelector('[data-inps-track]');
        if (track) track.scrollLeft = 0;
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in-tabs"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-intabs]').forEach(function(root){
    if (root.dataset.inited) return;
    root.dataset.inited = '1';
    var btns = root.querySelectorAll('.intabs__btn');
    var panels = root.querySelectorAll('.intabs__panel');
    btns.forEach(function(btn){
      btn.addEventListener('click', function(){
        var id = btn.getAttribute('data-tab');
        btns.forEach(function(b){ b.classList.remove('is-active'); });
        panels.forEach(function(p){ p.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var panel = root.querySelector('[data-panel="'+id+'"]');
        if (panel) panel.classList.add('is-active');
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in-threeshop"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-inps]').forEach(function(root){
    if (root.dataset.inited) return;
    root.dataset.inited = '1';
    var filters = root.querySelectorAll('[data-inps-filter]');
    var panels = root.querySelectorAll('[data-inps-panel]');
    filters.forEach(function(btn){
      btn.addEventListener('click', function(){
        var id = btn.getAttribute('data-inps-filter');
        filters.forEach(function(b){ b.classList.remove('is-active'); });
        panels.forEach(function(p){ p.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var panel = root.querySelector('[data-inps-panel="'+id+'"]');
        if (panel) panel.classList.add('is-active');
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in-twoshop"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-inps]').forEach(function(root){
    if (root.dataset.inited) return;
    root.dataset.inited = '1';
    var filters = root.querySelectorAll('[data-inps-filter]');
    var panels = root.querySelectorAll('[data-inps-panel]');
    filters.forEach(function(btn){
      btn.addEventListener('click', function(){
        var id = btn.getAttribute('data-inps-filter');
        filters.forEach(function(b){ b.classList.remove('is-active'); });
        panels.forEach(function(p){ p.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var panel = root.querySelector('[data-inps-panel="'+id+'"]');
        if (panel) panel.classList.add('is-active');
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in-vorteile-pro"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.invp').forEach(function(sec){
    var items=sec.querySelectorAll('.invp__item');
    var dots=sec.querySelectorAll('.invp__dot');
    var panels=sec.querySelectorAll('.invp__panel');
    function activate(i){
      items.forEach(function(el,n){el.classList.toggle('is-active',n===i)});
      dots.forEach(function(el,n){el.classList.toggle('is-active',n===i)});
      panels.forEach(function(el,n){el.classList.toggle('is-active',n===i)});
    }
    items.forEach(function(el,i){
      el.addEventListener('click',function(){activate(i)});
    });
    activate(0);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kaufkarte-pro-6"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.inbc6').forEach(function(root){
  var spIn = root.querySelector('[data-sp]');
  var cur = root.querySelector('[data-cur]');
  var showOnce = root.querySelector('[data-show-once]');
  var showAbo = root.querySelector('[data-show-abo]');
  var showStrike = root.querySelector('[data-show-strike]');
  var showPortion = root.querySelector('[data-show-portion]');
  var portionG = root.dataset.portionG || '30g';
  var aboFactor = 0.9;

  function fmt(c){ return '€' + (c/100).toFixed(2).replace('.', ','); }
  function getActivePill(){ return root.querySelector('.inbc6__pill.is-on'); }
  function isAbo(){ return spIn && spIn.value !== ''; }

  function update(){
    var pill = getActivePill();
    if(!pill) return;
    var cents = parseInt(pill.dataset.cents);
    var portions = parseInt(pill.dataset.portions) || 1;
    var aboCents = Math.round(cents * aboFactor);

    if(showOnce) showOnce.textContent = fmt(cents);
    if(showAbo) showAbo.textContent = fmt(aboCents);
    if(showStrike) showStrike.textContent = fmt(cents);

    var perCents = isAbo() ? aboCents : cents;
    var perPortion = Math.round(perCents / portions);
    if(showPortion){
      showPortion.textContent = portions + ' Portionen à ' + portionG + ' | Nur ' + fmt(perPortion) + ' pro Portion';
    }
    if(cur) cur.textContent = pill.dataset.val;
  }

  root.querySelectorAll('.inbc6__pill').forEach(function(b){
    b.addEventListener('click', function(){
      root.querySelectorAll('.inbc6__pill').forEach(function(p){p.classList.remove('is-on')});
      b.classList.add('is-on');
      update();
    });
  });
  root.querySelectorAll('.inbc6__plan').forEach(function(b){
    b.addEventListener('click', function(){
      root.querySelectorAll('.inbc6__plan').forEach(function(p){p.classList.remove('is-on')});
      b.classList.add('is-on');
      if(spIn) spIn.value = b.dataset.spVal || '';
      update();
    });
  });

  update();

  var qty = root.querySelector('[data-qty]');
  root.querySelector('[data-qm]')?.addEventListener('click', function(){ qty.value = Math.max(1, parseInt(qty.value||1)-1); });
  root.querySelector('[data-qp]')?.addEventListener('click', function(){ qty.value = parseInt(qty.value||1)+1; });

  var addBtn = root.querySelector('[data-add]');
  if(!addBtn) return;
  addBtn.addEventListener('click', function(e){
    e.preventDefault();
    var pill = getActivePill();
    if(!pill) return;
    var origLabel = addBtn.textContent;
    addBtn.disabled = true;

    var fd = new FormData();
    fd.append('id', pill.dataset.vid);
    fd.append('quantity', qty.value || 1);
    if(spIn && spIn.value) fd.append('selling_plan', spIn.value);
    fd.append('sections', 'cart-icon-bubble,cart-drawer');
    fd.append('sections_url', window.location.pathname);

    fetch('/cart/add.js', {method:'POST', body: fd, headers:{'Accept':'application/javascript','X-Requested-With':'XMLHttpRequest'}})
      .then(function(r){ return r.json(); })
      .then(function(data){
        if(data.status){ throw data; }
        if(data.sections && data.sections['cart-icon-bubble']){
          var bubble = document.getElementById('cart-icon-bubble');
          if(bubble){
            var html = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
            var newInner = html.querySelector('#shopify-section-cart-icon-bubble');
            if(newInner) bubble.innerHTML = newInner.innerHTML;
          }
        }
        if(data.sections && data.sections['cart-drawer']){
          var drawer = document.querySelector('cart-drawer');
          if(drawer){
            var dHtml = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
            var dInner = dHtml.querySelector('cart-drawer');
            if(dInner) drawer.innerHTML = dInner.innerHTML;
            drawer.classList.remove('is-empty');
          }
        }
        addBtn.textContent = '✓ Hinzugefügt';
        setTimeout(function(){ addBtn.textContent = origLabel; addBtn.disabled = false; }, 1800);
      })
      .catch(function(err){
        console.error(err);
        addBtn.disabled = false;
        addBtn.textContent = origLabel;
        alert('Fehler beim Hinzufügen.');
      });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kaufkarte-pro"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.inbc2').forEach(function(root){
  var idIn = root.querySelector('[data-id]');
  var cur = root.querySelector('[data-cur]');
  var showOnce = root.querySelector('[data-show-once]');
  var showAbo = root.querySelector('[data-show-abo]');
  var showStrike = root.querySelector('[data-show-strike]');
  var showPortion = root.querySelector('[data-show-portion]');
  var portionG = root.dataset.portionG || '30g';
  var aboFactor = 0.9;

  function fmt(c){ return '€' + (c/100).toFixed(2).replace('.', ','); }

  function getCheckedPill(){ return root.querySelector('.inbc2__pill input:checked'); }
  function getCheckedPlan(){ return root.querySelector('input[name=selling_plan]:checked'); }

  function update(){
    var pill = getCheckedPill();
    if(!pill) return;
    var cents = parseInt(pill.dataset.cents);
    var portions = parseInt(pill.dataset.portions) || 1;
    var aboCents = Math.round(cents * aboFactor);

    if(showOnce) showOnce.textContent = fmt(cents);
    if(showAbo) showAbo.textContent = fmt(aboCents);
    if(showStrike) showStrike.textContent = fmt(cents);

    var plan = getCheckedPlan();
    var isAbo = plan && plan.value !== '';
    var perCents = isAbo ? aboCents : cents;
    var perPortion = Math.round(perCents / portions);
    if(showPortion){
      showPortion.textContent = portions + ' Portionen à ' + portionG + ' | Nur ' + fmt(perPortion) + ' pro Portion';
    }
    if(idIn) idIn.value = pill.dataset.vid;
    if(cur) cur.textContent = pill.value;
  }

  root.querySelectorAll('.inbc2__pill').forEach(function(pill){
    pill.addEventListener('click', function(){
      var input = pill.querySelector('input');
      if(!input) return;
      input.checked = true;
      root.querySelectorAll('.inbc2__pill').forEach(function(p){p.classList.remove('is-on')});
      pill.classList.add('is-on');
      update();
    });
  });
  root.querySelectorAll('input[name=selling_plan]').forEach(function(r){
    r.addEventListener('change', update);
  });

  // Portion-Größe aus settings via data
  root.dataset.portionG = '{{ section.settings.portion_g }}';
  portionG = root.dataset.portionG;

  update();

  var qty = root.querySelector('[data-qty]');
  var qm = root.querySelector('[data-qm]');
  var qp = root.querySelector('[data-qp]');
  if(qm) qm.addEventListener('click', function(){ qty.value = Math.max(1, parseInt(qty.value||1)-1); });
  if(qp) qp.addEventListener('click', function(){ qty.value = parseInt(qty.value||1)+1; });

  var form = root.querySelector('form');
  if(!form) return;
  form.addEventListener('submit', function(e){
    e.preventDefault();
    var btn = form.querySelector('[name=add]');
    var origLabel = btn ? btn.textContent : '';
    if(btn) btn.disabled = true;
    var fd = new FormData(form);
    fd.append('sections', 'cart-icon-bubble,cart-drawer');
    fd.append('sections_url', window.location.pathname);
    fetch('/cart/add.js', {method:'POST', body: fd, headers:{'Accept':'application/javascript','X-Requested-With':'XMLHttpRequest'}})
      .then(function(r){ return r.json(); })
      .then(function(data){
        if(data.status){ throw data; }
        if(data.sections && data.sections['cart-icon-bubble']){
          var bubble = document.getElementById('cart-icon-bubble');
          if(bubble){
            var html = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
            var newInner = html.querySelector('#shopify-section-cart-icon-bubble');
            if(newInner) bubble.innerHTML = newInner.innerHTML;
          }
        }
        if(data.sections && data.sections['cart-drawer']){
          var drawer = document.querySelector('cart-drawer');
          if(drawer){
            var dHtml = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
            var dInner = dHtml.querySelector('cart-drawer');
            if(dInner) drawer.innerHTML = dInner.innerHTML;
            drawer.classList.remove('is-empty');
          }
        }
        if(btn){
          btn.textContent = '✓ Hinzugefügt';
          setTimeout(function(){ btn.textContent = origLabel; btn.disabled = false; }, 1800);
        }
      })
      .catch(function(err){
        console.error(err);
        if(btn){ btn.disabled = false; btn.textContent = origLabel; }
        alert('Fehler beim Hinzufügen.');
      });
  });
});

  } catch(e) { console.error(e); }
})();
})();
